import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AppointmentConfirmed = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);

        const isSuccess = sessionStorage.getItem('appointment_success');

        if (isSuccess !== 'true') {
            navigate('/book-appointment', { replace: true });
            return;
        }

        // ⏳ delay করে remove (StrictMode safe)
        setTimeout(() => {
            sessionStorage.removeItem('appointment_success');
        }, 100);

    }, [navigate]);

    return (
        <section className="confirm-wrapper">
            <div className="confirm-card">

                {/* ICON */}
                <div className="success-icon">
                  ✅
                </div>

                {/* HEADLINE */}
                <h2 className="confirm-title">
                    ধন্যবাদ! আপনার তথ্যটি আমরা পেয়েছি।
                </h2>
                <p className="confirm-subtitle">
                    Thank you! We have received your information.
                </p>

                {/* BODY */}
                <p className="confirm-text">
                    আমাদের একজন প্রতিনিধি আগামী <strong>২৪ ঘণ্টার মধ্যে</strong> আপনাকে <br /> কল করে
                    অ্যাপয়েন্টমেন্ট কনফার্ম করবেন।
                </p>

                <p className="confirm-text en">
                    One of our representatives will call you within <strong>24 hours </strong> 
                     to <br /> confirm your appointment.
                </p>

                <div className="confirm-call">
                    জরুরি প্রয়োজনে সরাসরি কল করুন / For emergency call directly:
                    <br />
                    <a href="tel:01944003077">Call Now : 01944-003077</a>
                </div>

                {/* BUTTON */}
                <Link to="/" className="confirm-btn">
                    Back to Home
                </Link>

            </div>
        </section>
    );
};

export default AppointmentConfirmed;